import { createFeatureSelector, createSelector } from '@ngrx/store';
import * as logoutState from '../reducers/logout.reducer';
import * as fromAuthReducer from '../auth.reducer';

//#region AUTH ROOT STATE
export const getAuthState = createFeatureSelector<fromAuthReducer.State, fromAuthReducer.AuthState>(fromAuthReducer.authFeatureKey);
//#endregion

//#region LOGOUT STATE
export const getLogoutState = createSelector(getAuthState, state => state[logoutState.logoutFeatureKey]);
//#endregion

export const getLogoutIsLoading = createSelector(getLogoutState, logoutState.getLogoutIsLoading);
export const getLogoutRequest = createSelector(getLogoutState, logoutState.getLogoutRequest);
export const getLogoutSuccess = createSelector(getLogoutState, logoutState.getLogoutResponse);
export const getLogoutFailure = createSelector(getLogoutState, logoutState.getLogoutFailure);
